<template>
  <div class="checkout-wrapper p-3 vh-100">
    <CustomerHeeader />
    <p class="header h4">Checkout</p>
    <div class="checkout-body">
      <div v-if="Object.values(cartItems).length>0" class="cart-items">
        <template v-for="(item) in cartItems">
          <div :key="'selected'+item.id" class="selected-options mb-2">
            <ItemCard :item="item" :editable="false" />
          </div>
        </template>
        <hr />
        <div class="total d-flex justify-content-between">
          <span>Total</span>
          <span>{{cartTotal(menu.id)|cuurency('€')}}</span>
        </div>
        <hr />
        <b-form-radio v-model="selected" name="In-House Order" value="In-House Order">In-House Order</b-form-radio>
        <b-form-radio v-model="selected" name="Pick Up" value="Pick Up">Pick Up</b-form-radio>
        <b-form-radio v-model="selected" name="Delivery" value="Delivery">Delivery</b-form-radio>
        <div v-if="selected==='In-House Order'" class="in-house-optons">
          <validation-observer v-slot="{invalid}">
            <TextInput
              :rules="'required'"
              type="number"
              placeholder="Enter table number"
              v-model="table.number"
            />
            <TextInput placeholder="Enter a message" v-model="table.message" />
            <!-- <Botton
              :onclick="checkout"
              buttonClass="btn btn-primary btn-round btn-md btn-block"
              text="Checkout"
              :disabled="invalid"
            />-->
            <h3>I'll pay with&hellip;</h3>
            <div class="list-group">
              <div class="list-group-item">
                <div class="list-group-item-heading">
                  <div class="row radio">
                    <div class="col-xs-3">
                      <label data-toggl-e="collapse" data-target="#newcard">
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios2"
                          value="option2"
                        />
                        A New Credit Card
                      </label>
                    </div>
                    <div class="col-xs-9">
                      <div class="media">
                        <a class="media-left" href="#">
                          <img
                            src="https://lovewithfood.com/assets/credit_cards/cards-b3a7c7b8345355bf110ebedfd6401312.png"
                            height="25"
                            alt
                          />
                        </a>
                        <div class="media-body" id="newcard">We accept these credit cards.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-group-item">
                <div class="list-group-item-heading">
                  <div class="row radio">
                    <div class="col-xs-3">
                      <label>
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios2"
                          value="option2"
                        />
                        PayPal
                      </label>
                    </div>
                    <div class="col-xs-9">
                      <div class="media">
                        <a class="media-left" href="#">
                          <img
                            src="https://www.paypalobjects.com/webstatic/mktg/logo-center/PP_Acceptance_Marks_for_LogoCenter_76x48.png"
                            height="25"
                            alt
                          />
                        </a>
                        <div
                          class="media-body"
                        >When you click "Place Order", you will be taken to the PayPal website.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="well">
              <Botton
                :onclick="openPayment"
                buttonClass="btn btn-primary  btn-md btn-block"
                text="Checkout"
                :disabled="invalid"
              />
            </div>
          </validation-observer>
        </div>

        <div v-else-if="selected==='Pick Up'" class="pickup-options">
          <validation-observer v-slot="{invalid}">
            <TextInput
              :rules="'required'"
              type="text"
              placeholder="Enter name"
              v-model="pickUp.name"
            />
            <TextInput
              :rules="'required|email'"
              type="email"
              placeholder="Enter email"
              v-model="pickUp.email"
            />
            <TextInput
              :rules="'required'"
              type="number"
              placeholder="Enter phone number"
              v-model="pickUp.number"
            />
            <TextInput placeholder="Enter a message" v-model="pickUp.message" />
            <!-- <Botton
              :onclick="checkout"
              buttonClass="btn btn-primary btn-round btn-md btn-block"
              text="Checkout"
              :disabled="invalid"
            />-->
            <h3>I'll pay with&hellip;</h3>
            <div class="list-group">
              <div class="list-group-item">
                <div class="list-group-item-heading">
                  <div class="row radio">
                    <div class="col-xs-3">
                      <label data-toggl-e="collapse" data-target="#newcard">
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios2"
                          value="option2"
                        />
                        A New Credit Card
                      </label>
                    </div>
                    <div class="col-xs-9">
                      <div class="media">
                        <a class="media-left" href="#">
                          <img
                            src="https://lovewithfood.com/assets/credit_cards/cards-b3a7c7b8345355bf110ebedfd6401312.png"
                            height="25"
                            alt
                          />
                        </a>
                        <div class="media-body" id="newcard">We accept these credit cards.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-group-item">
                <div class="list-group-item-heading">
                  <div class="row radio">
                    <div class="col-xs-3">
                      <label>
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios2"
                          value="option2"
                        />
                        PayPal
                      </label>
                    </div>
                    <div class="col-xs-9">
                      <div class="media">
                        <a class="media-left" href="#">
                          <img
                            src="https://www.paypalobjects.com/webstatic/mktg/logo-center/PP_Acceptance_Marks_for_LogoCenter_76x48.png"
                            height="25"
                            alt
                          />
                        </a>
                        <div
                          class="media-body"
                        >When you click "Place Order", you will be taken to the PayPal website.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="well">
              <Botton
                :onclick="openPayment"
                buttonClass="btn btn-primary btn-md btn-block"
                text="Checkout"
                :disabled="invalid"
              />
            </div>
          </validation-observer>
        </div>

        <div v-else class="delivery-options">
          <validation-observer v-slot="{invalid}">
            <TextInput
              :rules="'required'"
              type="text"
              placeholder="Enter name"
              v-model="delivery.name"
            />
            <TextInput
              :rules="'required|email'"
              type="email"
              placeholder="Enter email"
              v-model="delivery.email"
            />
            <TextInput
              :rules="'required'"
              type="number"
              placeholder="Enter phone number"
              v-model="delivery.number"
            />
            <TextInput
              :rules="'required'"
              type="text"
              placeholder="Enter address"
              v-model="delivery.address"
            />
            <TextInput placeholder="Enter a message" v-model="delivery.message" />
            <!-- <Botton
              :onclick="checkout"
              buttonClass="btn btn-primary btn-round btn-md btn-block"
              text="Checkout"
              :disabled="invalid"
            />-->
            <h3>I'll pay with&hellip;</h3>
            <div class="list-group">
              <div class="list-group-item">
                <div class="list-group-item-heading">
                  <div class="row radio">
                    <div class="col-xs-3">
                      <label data-toggl-e="collapse" data-target="#newcard">
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios2"
                          value="option2"
                        />
                        A New Credit Card
                      </label>
                    </div>
                    <div class="col-xs-9">
                      <div class="media">
                        <a class="media-left" href="#">
                          <img
                            src="https://lovewithfood.com/assets/credit_cards/cards-b3a7c7b8345355bf110ebedfd6401312.png"
                            height="25"
                            alt
                          />
                        </a>
                        <div class="media-body" id="newcard">We accept these credit cards.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-group-item">
                <div class="list-group-item-heading">
                  <div class="row radio">
                    <div class="col-xs-3">
                      <label>
                        <input
                          type="radio"
                          name="optionsRadios"
                          id="optionsRadios2"
                          value="option2"
                        />
                        PayPal
                      </label>
                    </div>
                    <div class="col-xs-9">
                      <div class="media">
                        <a class="media-left" href="#">
                          <img
                            src="https://www.paypalobjects.com/webstatic/mktg/logo-center/PP_Acceptance_Marks_for_LogoCenter_76x48.png"
                            height="25"
                            alt
                          />
                        </a>
                        <div
                          class="media-body"
                        >When you click "Place Order", you will be taken to the PayPal website.</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="well">
              <Botton
                :onclick="openPayment"
                buttonClass="btn btn-primary btn-md btn-block"
                text="Checkout"
                :disabled="invalid"
              />
            </div>
          </validation-observer>
        </div>
      </div>
      <template v-else>
        <div class="d-flex align-items-center h-75 justify-content-center">
          <p>No items to checkout!</p>
        </div>
      </template>
      <b-modal id="payment-form" @ok="checkout" title="Make Payments">
        <div class="row">
          <div class="col-lg-7 mx-auto">
            <b-tabs content-class="mt-3" fill>
              <b-tab title="Card">
                <div id="nav-tab-card" class="tab-pane fade show active">
                  <div class="col-sm-8 col-md-6">
                    <div class="card">
                      <div class="card-header">
                        <div class="row">
                          <div class="col-md-6">
                            <span>CREDIT/DEBIT CARD PAYMENT</span>
                          </div>
                          <div class="col-md-6 text-right" style="margin-top: -5px;">
                            <img src="https://img.icons8.com/color/36/000000/visa.png" />
                            <img src="https://img.icons8.com/color/36/000000/mastercard.png" />
                            <img src="https://img.icons8.com/color/36/000000/amex.png" />
                          </div>
                        </div>
                      </div>
                      <div class="card-body" style="height: 350px">
                        <div class="form-group">
                          <label for="cc-number" class="control-label">CARD NUMBER</label>
                          <input
                            id="cc-number"
                            type="tel"
                            class="input-lg form-control cc-number"
                            autocomplete="cc-number"
                            placeholder="•••• •••• •••• ••••"
                            required
                          />
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="cc-exp" class="control-label">CARD EXPIRY</label>
                              <input
                                id="cc-exp"
                                type="tel"
                                class="input-lg form-control cc-exp"
                                autocomplete="cc-exp"
                                placeholder="•• / ••"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="cc-cvc" class="control-label">CARD CVC</label>
                              <input
                                id="cc-cvc"
                                type="tel"
                                class="input-lg form-control cc-cvc"
                                autocomplete="off"
                                placeholder="••••"
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <label for="numeric" class="control-label">CARD HOLDER NAME</label>
                          <input type="text" class="input-lg form-control" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Paypal">
                <div id="nav-tab-card" class="tab-pane fade show active">
                  <p>Paypal is easiest way to pay online</p>
                  <p>
                    <button type="button" class="btn btn-primary rounded-pill">
                      <i class="fa fa-paypal mr-2"></i> Log into my Paypal
                    </button>
                  </p>
                </div>
              </b-tab>
              <b-tab title="Bank">
                <div id="nav-tab-card" class="tab-pane fade show active">
                  <h6>Bank account details</h6>
                  <dl>
                    <dt>Bank</dt>
                    <dd>THE WORLD BANK</dd>
                  </dl>
                  <dl>
                    <dt>Account number</dt>
                    <dd>7775877975</dd>
                  </dl>
                  <dl>
                    <dt>IBAN</dt>
                    <dd>CZ7775877975656</dd>
                  </dl>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import ItemCard from "../pages/components/customer/ItemCard";
import Botton from "../pages/components/Botton";
import { mapGetters, mapActions } from "vuex";
import { ValidationObserver } from "vee-validate";
import TextInput from "../pages/components/Inputs/TextInput";
import CustomerHeeader from "../pages/components/customer/customerHeader";
//import Radio from "../components/Inputs/Radio";
export default {
  components: {
    ItemCard,
    Botton,
    ValidationObserver,
    TextInput,
    CustomerHeeader
  },
  data() {
    return {
      username: null,
      menu_slug: null,
      selected: "In-House Order",
      table: {},
      delivery: {},
      pickUp: {}
    };
  },
  methods: {
    ...mapActions({
      newOrder: "Order/addNewOrder"
    }),
    async fetchMenu() {
      const response = await this.$store.dispatch("MenuView/getCurrentMenu", {
        username: this.username,
        menu_slug: this.menu_slug
      });
    },
    removeItem(item) {
      this.$store.commit("Cart/REMOVE_FROM_CART", {
        item,
        currentMenu: this.menu.id
      });
    },
    openPayment() {
      this.$bvModal.show("payment-form");
    },
    checkout() {
      let data = {
        orderList: this.cartItems,
        menuId: this.menu.id,
        companyId: this.currentComapny.id,
        menu: this.menu,
        total: this.cartTotal(this.menu.id),
        type: this.selected,
        username: this.$route.params.username,
        menu_slug: this.$route.params.menu_slug
      };
      switch (this.selected) {
        case "In-House Order":
          data.details = this.table;
          break;
        case "Pick Up":
          data.details = this.pickUp;
          break;
        case "Delivery":
          data.details = this.delivery;
          break;
        default:
          return;
      }
      this.newOrder(data);
    }
  },
  computed: {
    ...mapGetters({
      cartTotal: "Cart/cartTotal"
    }),
    menu() {
      return this.$store.state.MenuView.currentMenu;
    },
    currentComapny() {
      return this.$store.state.MenuView.currentCompany;
    },
    cartItems() {
      if (!this.menu) {
        return {};
      }
      if (!this.$store.state.Cart.cart[this.menu.id]) {
        return {};
      } else {
        return this.$store.state.Cart.cart[this.menu.id];
      }
    }
  },
  mounted() {
    this.username = this.$route.params.username;
    this.menu_slug = this.$route.params.menu_slug;
    this.fetchMenu();
  }
};
</script>

<style scoped>
.checkout-wrapper {
  background: white;
}
</style>